import { useEffect, useState } from "react";

export type ThemePreference = "system" | "light" | "dark";
const themeKey = "xlacking.theme";

export function useTheme() {
  const [theme, setTheme] = useState<ThemePreference>(() => {
    const stored = window.localStorage.getItem(themeKey);
    return stored === "light" || stored === "dark" || stored === "system" ? stored : "light";
  });
  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      const resolved = theme === "system" ? (media.matches ? "dark" : "light") : theme;
      document.documentElement.dataset.theme = resolved;
      document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute("content", resolved === "dark" ? "#1a1d21" : "#ffffff");
    };
    apply();
    window.localStorage.setItem(themeKey, theme);
    if (theme === "system") media.addEventListener("change", apply);
    return () => { media.removeEventListener("change", apply); };
  }, [theme]);
  return { theme, setTheme };
}
